export function buildPublicUrl(objectPath) {
  if (!objectPath) return null;

  // If caller accidentally passes a full URL, just return it
  if (/^https?:\/\//i.test(objectPath)) return objectPath;

  const base = (process.env.REACT_APP_PHOTOBUCKET_URL || "").replace(/\/$/, "");
  if (!base) return null; // no base configured

  // ensure no leading slash on objectPath and safely encode (keeps / intact)
  const cleaned = String(objectPath).replace(/^\/+/, "");
  return `${base}/${encodeURI(cleaned)}`;
}


export const getReadableRouteName = (routes, path) => {
  const matched = Object.entries(routes).find(([_, route]) => route === path);
  if (!matched) return path; // fallback if not found

  const [enumName] = matched;
  return enumName
    .toLowerCase()
    .replace(/_/g, " ") // PROFILE_EDIT → profile edit
    .replace(/\b\w/g, (c) => c.toUpperCase()); // capitalize → Profile Edit
};